module.exports = __webpack_public_path__ + "img/book_xb.cfd59349.svg";